import React from 'react';
import Auth from 'works/legacy/lib/auth';
import { useNavigate } from '@common/hooks';

import { FourZeroFour } from 'works/pages/errors/four-zero-four';

export function NoMatch() {
  const navigate = useNavigate();

  // If a supplier is trying to access /works, send to proper supplier home page
  if (
    Auth.signedIn() &&
    (window.location.pathname === '/works' ||
      window.location.pathname === '/works/')
  ) {
    if (Auth.supplierMember()) navigate('/works/supplier');
    return null;
  }

  return <FourZeroFour />;
}
